<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/school_list' }">学校管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!form1.uuid">新增学校</el-breadcrumb-item>
      <el-breadcrumb-item v-else>修改学校</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="id-wrapper" v-if="form1.schoolNo">
      <div class="left">学校编码</div>
      <div class="right">
        {{form1.schoolNo}}
      </div>
    </div>
    <el-form
      ref="form1"
      :model="form1"
      inline
      label-width="120px"
      class="form1">
      <el-form-item label="学校名称" prop="schoolName" :rules="rules.schoolName">
        <el-input v-model="form1.schoolName"></el-input>
      </el-form-item>
      <el-form-item label="学校类别" prop="type" :rules="rules.schoolName" style="padding-right: 15px;">
        <el-select v-model="form1.type" placeholder="请选择学校类别">
          <el-option label="未认证" :value="0"></el-option>
          <el-option label="已认证小客户" :value="1"></el-option>
          <el-option label="已认证大客户" :value="2"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form
      :model="form2"
      inline
      label-width="120px"
      class="form2">
      <div v-for="(item, index) in form2.admins" :key="index">
        <el-form-item label="管理员" :prop="'admins.' + index +'.adminName'" :rules="moreRules.adminName">
          <el-input v-model="item.adminName" :disabled="!!item.uuid"></el-input>
        </el-form-item>
        <el-form-item label="管理员手机号" :prop="'admins.' + index +'.adminPhoneNo'" :rules="moreRules.adminPhoneNo">
          <el-input v-model="item.adminPhoneNo" :disabled="!!item.uuid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" size="mini" @click="deleteContact(index)" icon="el-icon-minus" circle></el-button>
        </el-form-item>
      </div>
    </el-form>
    <el-form label-width="120px" class="form1">
      <el-form-item style="width: 646px; text-align: center;">
        <el-button type="primary" @click="addContact()" :loading="loading">增加管理员</el-button>
        <el-button type="primary" @click="onSubmit(1)" v-if="!form1.uuid" :loading="loading">立即创建</el-button>
        <el-button type="primary" @click="onSubmit(2)" v-else :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapGetters } from 'vuex';
  import { slice } from 'lodash';
  import { trimString } from '@/common/js/util';
  import { schoolUtil } from '@/api/school';
  import index from '../store';

  export default {
    // name: 'add_school'
    data() {
      return {
        form1: {
          schoolName: '',
          type: '',
        },
        form2: {
          admins: [{ adminName: '', adminPhoneNo: '' }]
        },
        form3: {
          admins: [],
        },
        rules: {
          schoolName: [
            { required: true, message: '请输入学校名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择学校类别', trigger: 'change' },
          ],
        },
        moreRules: {
          adminName: [
            { required: true, message: '请输入管理员姓名', trigger: 'blur' }
          ],
          adminPhoneNo: [
            { required: true, message: '管理员手机号', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                let valArr = [];

                for (let i = 0; i < this.form2.admins.length; i++) {
                  if (this.form2.admins[i]['adminPhoneNo'] === value) {
                    valArr.push(this.form2.admins[i]);
                  }
                }
                if (valArr.length >= 2) {
                  callback(new Error('手机号重复'));
                }
              },
              trigger: 'blur'
            }
          ]
        },
        loading: false
      };
    },
    mounted() {
      if (this.$route.params.id) {
        this.form1 = Object.assign({}, this.form1, this.school);
        this.form2.admins = slice(this.school.admins);
      }
    },
    methods: {
      addContact() {
        if (this.form2.admins.length === 10) {
          this.$message.warning('最多可添加10个管理员');
          return;
        }
        this.form2.admins.push({
          adminName: '',
          adminPhoneNo: ''
        });
      },
      deleteContact(index) {
        if (!this.form2.admins[index].uuid) {
          this.form2.admins.splice(index, 1);
        } else {
          this.form3.admins.push(this.form2.admins[index]);
          this.form2.admins.splice(index, 1);
        }
      },
      onSubmit(type) {
        if (!this.form1.schoolName || !trimString(this.form1.schoolName)) {
          this.$message.warning('请上输入学校名称');
          return;
        }
        if (!this.form1.type === '') {
          this.$message.warning('请选择学校类别');
          return;
        }
        for (let i = 0; i < this.form2.admins.length; i++) {
          if (!this.form2.admins[i].adminName || !trimString(this.form2.admins[i].adminName)) {
            this.$message.warning(`请上输入管理员${i}的姓名`);
            return;
          } else if (!this.form2.admins[i].adminPhoneNo || !trimString(this.form2.admins[i].adminPhoneNo)) {
            this.$message.warning(`请上输入管理员${i}的手机号`);
            return;
          }
        }
        this.form1.userId = this.user.userId;
        this.loading = true;
        switch (type) {
          case 1:
            this.form1 = Object.assign({}, this.form1, this.form2);
            schoolUtil(this.form1, 1).then((res) => {
              this.loading = false;
              if (res.rspCode === 0) {
                this.$message.success('新增学校成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.rspDesc);
              }
            }).catch(e => {
              this.loading = false;
            });
            break;
          case 2:
            this.form2.admins.map((item, index) => {
              if (!item.uuid) {
                this.form3.admins.push(this.form2.admins[index]);
              }
            });
            this.form1 = Object.assign({}, this.form1, this.form3);
            schoolUtil(this.form1, 2).then((res) => {
              this.loading = false;
              if (res.rspCode === 0) {
                this.$message.success('保存学校成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.rspDesc);
              }
            }).catch(e => {
              this.loading = false;
            });
            break;
        }
      }
    },
    computed: {
      ...mapGetters([
        'school',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .id-wrapper
      display: flex;
      margin-bottom: 22px;
      .left
        flex: 0 0 120px;
        width: 120px;
        padding-right: 12px;
        box-sizing: border-box;
        text-align: right;
        font-size: 14px;
        color: #606266;
      .right
        flex: 1;
        font-size: 14px;
        color: #606266;
    .form1
      /*width: 300px;*/
    .form2
      width: 100%;
</style>